/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { headerShipToAddressStyles } from "@insite/content-library/Widgets/Common/HeaderShipToAddress";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

headerShipToAddressStyles.drawer = {
    closeButtonProps: {
        shape: "pill",
        buttonType: "solid",
        color: "danger.main",
        sizeVariant: "small",
        size: 42,
    },
    closeButtonIconProps: {
        src: "X",
        size: 20,
    },
    cssOverrides: {
        drawerContent: css`
            height: 100%;
            overflow-y: inherit;
            margin: 0 -12px;
        `,
        drawerBody: css`
            background: ${getColor("common.background")};
            overflow-x: inherit;
            overflow-y: inherit;
            top: 50%;
            transform: translate(-50%, -50%);
            padding: 30px 20px 25px 20px;
            height: auto;
            min-height: 260px;
            width: 90%;
            left: 50%;
            box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.5);
            border-radius: 6px;
            max-width: 1088px;
        `,
        drawerTitle: css`
            margin-bottom: 15px;
            padding-bottom: 10px;
            border-bottom: 1px solid ${getColor("common.ui12")};
            width: 100%;
            line-height: 26px;
            background: ${getColor("common.background")};

            ${TypographyStyle as any} {
                margin: 0;
                font-size: 20px;
            }

            > button {
                line-height: 1;
                position: absolute;
                top: -13px;
                right: -13px;
                margin: 0;
                border: 3px solid ${getColor("text.inverse")};
                background-color: ${getColor("danger.main")};
                box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);
                border-radius: 50%;
                width: 42px !important;
                height: 42px;
                padding: 0;

                > span {
                    position: unset !important;
                    top: 0 !important;
                }

                > span,
                svg {
                    color: ${getColor("text.inverse")};
                    stroke-width: 4px;
                }

                &:hover,
                &:focus {
                    border-color: ${getColor("text.inverse")} !important;
                    background: ${getColor("common.ui16")} !important;
                }
            }
        `,
    },
    headlineTypographyProps: {
        color: "text.main",
        forwardAs: "h3",
        variant: "h4",
    },
};
